import React from 'react';
import { FiBell } from 'react-icons/fi';
import './NotificationBell.css';

export default function NotificationBell({ count = 0, onClick }) {
  return (
    <button
      className={`notif-bell ${count ? 'notif-bell-active' : ''}`}
      onClick={onClick}
      aria-label={`Notificaciones, ${count} sin leer`}
      type="button"
    >
      <FiBell className="notif-bell-icon" />
      {count > 0 && (
        <span className="notif-bell-badge">
          {count > 99 ? '99+' : count}
        </span>
      )}
    </button>
  );
}
